import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)

import { useI18n, createNamespacedT, mergeMessages } from '@/i18n';
import InfoForm from './info-form.vue';
import sentEmail from './sent-email.vue';
import { PropType, ref, watch } from 'vue';
import { LocaleMessages } from 'vue-i18n';
import { AemAssetMap } from '@/types';
import { useLoginHelpStore } from '@/store';

type Route = 'info-form' | 'email' | 'login'


export default /*#__PURE__*/_defineComponent({
  __name: 'forgot-username',
  props: {
    i18nMessages: {
        type: Object as PropType<LocaleMessages<unknown>>,
        default: () => ({}),
    },
    assets: {
        type: Object as PropType<AemAssetMap>,
        default: () => ({}),
    }
},
  setup(__props) {

const props = __props;

const loginHelpStore = useLoginHelpStore();
const i18n = useI18n();
const tNamespace = 'forgotUsername';
const route = ref<Route>('info-form');
const tns = createNamespacedT(i18n, tNamespace);



watch(() => props.i18nMessages, (i18nMessages) => {
    mergeMessages(i18n, i18nMessages);
}, { immediate: true });

watch(() => props.assets, (assets) => {
    loginHelpStore.setAemAssets(assets);
}, { immediate: true });

const updateRoute = (newRoute: Route) => {
    route.value = newRoute;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h1", null, _toDisplayString(_unref(tns)('common.title')), 1 /* TEXT */),
    _hoisted_1,
    (route.value === 'info-form')
      ? (_openBlock(), _createBlock(InfoForm, {
          key: 0,
          onUpdateRoute: updateRoute
        }))
      : _createCommentVNode("v-if", true),
    (route.value === 'email')
      ? (_openBlock(), _createBlock(sentEmail, {
          key: 1,
          onUpdateRoute: updateRoute
        }))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})